/** Route paths for the milkability module. */
export const milkabilityRoutePaths = {
    overview: '/milkability',
    newReport: '/milkability/new',
    reportDetail: '/milkability/:id',
};
